 import testimonialsPepole from "./testimonialsPepole.json";
 import testimonialsPrintScreen from "./testimonialsPrintScreen.json";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
 

const settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1700,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function replaceKerk(text) {
  try {
    if (typeof text !== "string") return text;
    return text.replace(/קרק/g, "Kerk");
  } catch (error) {
    console.error("replaceKerk error:", error);
    return text; // במקרה של שגיאה – מחזיר את הטקסט המקורי
  }
}



function TestimonialCards() {
  return (
 
      <div
        style={{
          width: " ",
          maxWidth: " ",
      //     backgroundColor: "black",
      //  paddingTop:"100px",
        }}
      >
     <Slider {...settings}>
  {testimonialsPepole.map(({ id, name, company, content, image ,title}) => (
    <div key={id}>
      <div className="testimonial-card-pepole"  >

        <div style={{position:"relative" }} className="------the--top---part------" > 
        <img className="quote-img" src="testimonials/quote.svg" alt={`Quote`} /> 
        <img src="testimonials/starts.svg"alt="stars" style={{marginLeft:"auto" , marginRight:"auto" }}  />
        <div className="content-box mt-s-20"> <p className="content rtl" dir="rtl">"{content}"</p> </div>
        </div>

        <div style={{display:"flex" ,justifyContent:"space-between" ,gap:"10px", alignItems:"center"}}  className="------the--deatails---part------">    
       <img className="deatails-img" src={image} alt={`${name} - ${company}`} />  
       <div>
       < h5 className="deatails-name"  dir="rtl">{name}</ h5>
        <p className="deatails-title"  dir="rtl">{title}</p>
        <p className="deatails-company  small-bold-note"  dir="rtl">{company}</p>
        
       </div>

        </div>

    
      
      </div>
    </div>
  ))} 

  
  {testimonialsPrintScreen.map(({ id, imageButtom,  imageTop ,clentTopName , clientButtomName}) => (
    <div key={id}>
      <div className="testimonial-card-print-screen"  >

        <div className="image-magnified-box"> 
           
             <img src={imageTop} alt={`${imageTop} - ${clentTopName}`} className="image-magnified"/>
              <img className="quote-img-for-top-print-screen" src="testimonials/quote.svg" alt={`Quote`} /> 
                {/* <img className="quote-img-for-buttom-print-screen" src="testimonials/quote.svg" alt={`Quote`} /> */}
              
              </div>  
        <div className="image-magnified-box"> 
            
             <img src={imageButtom} alt={`${imageButtom} - ${clientButtomName}`} className="image-magnified"/> 
                 <img className="quote-img-for-top-print-screen" src="testimonials/quote.svg" alt={`Quote`} /> 
                {/* <img className="quote-img-for-buttom-print-screen" src="testimonials/quote.svg" alt={`Quote`} /> */}
             </div>  
           
      </div>
    </div>
  ))} 



 



</Slider>



        {/* STYLE for Dots */}
        <style>
          {`
            .slick-dots {
              bottom: -35px;
            }

            .slick-dots li button:before {
              font-size: 16px;
               color: grey  !important;
         
              opacity: 1;
            }

            .slick-dots li.slick-active button:before {
                  color: white !important;
            }

//             .slick-slide {
//   overflow: visible !important;
// }

// .slick-list {
//   overflow: visible !important;
// }
          `}
        </style>
      </div>
  
  );
}

export default TestimonialCards;


 



